module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.isLoading) ? _c('loading') : _vm._e(), (!_vm.isLoading) ? _c('bar-chart', {
    attrs: {
      "isHorizontal": false,
      "series": _vm.series,
      "categories": _vm.categories,
      "yAxisTitle": "Dias disponibles",
      "tooltipFormatter": _vm.tooltipFormatter,
      "title": "Top 10 empleados con más días disponibles",
      "showLegend": false,
      "showXlabels": true
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d0b4ba0a","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/kpis/c_kpi_top_empleados_mas_dias_disponibles.vue
// module id = 878
// module chunks = 0